import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrashBininline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Delete/24px",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle-33",
				stroke: "#000000",
				strokeWidth: 2,
				x: 5,
				y: 6,
				width: 14,
				height: 15,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2,6 L22,6",
				id: "Rectangle-33",
				stroke: "#000000",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("polygon", {
				id: "Rectangle-33",
				stroke: "#000000",
				strokeWidth: 2,
				points: "7 6 8 3 16 3 17 6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5,13.5 L6.5,13.5",
				id: "Line",
				stroke: "#000000",
				strokeWidth: 2,
				transform: "translate(10.000000, 13.500000) scale(-1, 1) rotate(-90.000000) translate(-10.000000, -13.500000) "
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.5,13.5 L10.5,13.5",
				id: "Line",
				stroke: "#000000",
				strokeWidth: 2,
				transform: "translate(14.000000, 13.500000) scale(-1, 1) rotate(-90.000000) translate(-14.000000, -13.500000) "
			})
		]
	})
});
export default SvgTrashBininline;
